export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9747.3a57a82e.jpg";